import script from "./project-report.vue?vue&type=script&setup=true&lang=js"
export * from "./project-report.vue?vue&type=script&setup=true&lang=js"

import "./project-report.vue?vue&type=style&index=0&id=303c72d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-303c72d0"]])

export default __exports__